import messageResource from '../../../messageResource'
import Node from './Node'

export default class OtherProjectsNode extends Node {

    constructor({
        onClick = () => {},
    }) {
        super()

        this.onClick = onClick

        this.state = {
            ...this.state,
            collapsed: true,
            onlyOtherProjectsInCustomer: false,
        }

        this.onStatePropertyChanged('collapsed', collapsed => {
            this.getEl().toggleClass('onlySeparator', !collapsed)
            this.$nodeContent.toggle(collapsed)
        })

        this.onStatePropertyChanged('onlyOtherProjectsInCustomer', onlyOtherProjectsInCustomer => {
            this.find('.separator').toggle(!onlyOtherProjectsInCustomer)
            this.$title.text(onlyOtherProjectsInCustomer ? messageResource.getMessage('customers_projects.view_customer_projects')
                                                         : messageResource.getMessage('customers_projects.view_other_customer_projects'))
        })
    }

    templateHtml() {
        return "<div class='node projectNode otherProjectsNode'>" +
               "  <div class='separator'/>" +
               "  <div class='nodeContent'>" +
               "    <div class='icon'></div>" +
               "    <div class='title'></div>" +
               "  </div>" +
               "</div>";
    }

    afterRender() {
        this.$nodeContent = this.find('.nodeContent')
        this.$title = this.find('.title')
        this.getEl().click(() => {
            this.setState({collapsed: !this.state.collapsed})
            this.onClick()
        })
        this.renderInitialState()
    }

    isCollapsed() {
        return this.state.collapsed
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/OtherProjectsNode.js